// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___1--tN","text":"text___KLxEm","message":"message___14fCr"};